import React from 'react';
import { TouchableOpacity, StyleSheet, Text } from 'react-native';
import { MainColors } from '../../constants/Colors';
import FontSizes from '../../constants/FontSizes';

const MainButton = (props) => {
    return (
        <TouchableOpacity
            disabled={props.disabled}
            style={[styles.buttonContainer, props.style]}
            onPress={props.onPress}
            accessibilityLabel={props.accessibilityLabel}
            accessibilityRole={"button"}>
            <Text style={styles.buttonText} accessibilityHint={props.accessibilityHint}>
                {props.text}
            </Text>
        </TouchableOpacity>
    )
}

const styles = StyleSheet.create({
    buttonContainer: {
        backgroundColor: MainColors.primary,
        paddingVertical: 10,
        height: 52,
        minWidth: 260,
        maxWidth: 520,
        borderRadius: 30,
        justifyContent: 'center',
        alignSelf: 'center'
    },
    buttonText: {
        color: 'white',
        fontSize: FontSizes.medium,
        fontWeight: '700',
        textAlign: 'center',
        letterSpacing: 0.5
    }
});

export default MainButton;